import React from 'react';
import './DropdownItem.scss';

const DropdownItem = ({handleClick, icon, text}) => {

  return (
    <div className="lock-item" value={text} onClick={handleClick}>{icon}{text}</div>
  );
};

export default DropdownItem;

DropdownItem.propTypes = {
};

DropdownItem.defaultProps = {
};

